var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiddenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hidden_icon",
    transform: "translate(-314 -1337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2664",
    "data-name": "Path 2664",
    d: "M26,0H0V26H26Z",
    transform: "translate(314 1337)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2661",
    "data-name": "Path 2661",
    d: "M3.609,7.276a8.576,8.576,0,0,0-1.675,3.092,8.608,8.608,0,0,0,10.584,5.816M5.449,5.642a8.6,8.6,0,0,1,12.964,4.723A8.614,8.614,0,0,1,14.9,15.092m-9.45-9.45L2.807,3M5.449,5.642,8.437,8.63M14.9,15.092l2.642,2.642M14.9,15.092,11.911,12.1m0,0A2.456,2.456,0,0,0,8.438,8.631M11.91,12.1,8.439,8.632",
    transform: "translate(316.826 1339.633)",
    fill: "none",
    stroke: "#52555e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenIcon);
export default __webpack_public_path__ + "static/media/hidden_icon.dd6d1120eccb83ad09e23594876206ab.svg";
export { ForwardRef as ReactComponent };